import { Buffer } from "buffer";

import UploadService from "../services/upload.service";

const getImageMimeType = (extension: string): string => {
  if (extension === "jpg" || extension === "jpeg") return "image/jpeg";
  if (extension === "webp") return "image/webp";
  if (extension === "gif") return "image/gif";
  if (extension === "svg") return "image/svg+xml";
  return "image/png";
};

class AmazonS3 {
  public async uploadPhoto(
    name: string,
    photo: Buffer | Uint8Array | ArrayBuffer,
    extension = "png"
  ): Promise<string> {
    const normalizedExtension = extension.replace(/^\./, "").toLowerCase() || "png";
    const fileName = `${name}.${normalizedExtension}`;
    const photoBase64 = Buffer.from(photo).toString("base64");
    const uri = `data:${getImageMimeType(normalizedExtension)};base64,${photoBase64}`;

    const response = await UploadService.uploadFile({ filename: fileName, uri });
    const url = response?.data?.url;
    if (!url) throw new Error("Error on AmazonS3.upload: empty upload url response");
    return url;
  }
}

export default new AmazonS3();
